<template>
  <div class="col-24">
    <div class="d-flex align-self-start">
      <div
        class="position-relative align-self-center d-flex align-items-center align-self-center"
      >
        <div
          class="circle-number d-flex justify-content-center align-items-center"
        >
          <span>{{ number }}</span>
        </div>
      </div>
      <div class="pl-3 d-flex">
        <div class="align-self-start mt-1">
          <h2 class="size-1_4 m-0 pb-1">
            <strong v-text="$ml.get('rewards')">Recompensas</strong>
          </h2>
          <p class="d-flex align-items-center">
            <span
              class="align-self-center"
              v-text="$ml.get('informTheRecommendations')"
            >
              Informe as recomensas que o especialista vai obter caso tenha
              sucesso!
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>

    <!-- Tipo de moeda -->
    <div v-if="!currency" class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div v-if="!currency" class="d-flex flex-column w-100 mr-3">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <label v-text="$ml.get('selectCurrencyType')">Selecione o tipo de moeda</label>
              <multiselect
                v-model="optionSelected"
                :options="listOptions"
                :searchable="false"
                label="value"
                :custom-label="langCurrency"
                :close-on-select="true"
                :show-labels="false"
                :allow-empty="false"
                :preselect-first="true"
                :multiple="false"
              >
              </multiselect>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!currency" class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100 mr-3">
        <p class="pl-3 mb-3" v-text="$ml.get('startWithRewards')">
          Começe pelas recomensas que possuem valor financeiro
        </p>

        <div class="card card-body ml-3 p-0 d-flex w-100">
          <table class="mb-2">
            <thead>
              <tr>
                <th
                  :class="[
                    'pl-3',
                    'pl-0',
                    {
                      'col-8':
                        this.bounty_severity.offers_double_bounty == true &&
                        this.bounty_severity.active_campaign,
                    },
                    {
                      'col-12':
                        !this.bounty_severity.active_campaign ||
                        !this.bounty_severity.offers_double_bounty,
                    },
                  ]"
                  v-text="$ml.get('severity')"
                >
                  Severidade
                </th>
                <th
                  :class="[
                    'pl-0',
                    {
                      'col-8':
                        this.bounty_severity.offers_double_bounty == true &&
                        this.bounty_severity.active_campaign,
                    },
                    {
                      'col-12':
                        !this.bounty_severity.active_campaign ||
                        !this.bounty_severity.offers_double_bounty,
                    },
                  ]"
                  v-text="$ml.get('reward')"
                >
                  Recompensa
                </th>
                <th
                  v-if="
                    this.bounty_severity.active_campaign &&
                    this.bounty_severity.offers_double_bounty
                  "
                  class="col-8 pl-0"
                  v-text="$ml.get('doubleReward')"
                >
                  Recompensa em dobro
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  :class="[
                    'row',
                    'd-flex',
                    'align-content-center',
                    {
                      'col-lg-8':
                        this.bounty_severity.offers_double_bounty == true &&
                        this.bounty_severity.active_campaign,
                      'col-12':
                        !this.bounty_severity.active_campaign ||
                        !this.bounty_severity.offers_double_bounty,
                    },
                  ]"
                >
                  <Impact impact="impact-low" class="mt-1" />
                  <strong class="mx-2" v-text="$ml.get('low')">Baixo</strong>
                </td>
                <td
                  :class="[
                    'pl-0',
                    'text-muted',
                    {
                      'col-lg-8':
                        this.bounty_severity.offers_double_bounty == true &&
                        this.bounty_severity.active_campaign,
                      'col-12':
                        !this.bounty_severity.active_campaign ||
                        !this.bounty_severity.offers_double_bounty,
                    },
                  ]"
                >
                  <div class="col-lg-24 col-mb-12" style="position: relative">
                    <label v-show="isDollar" class="currency">US$</label>
                    <label v-show="!isDollar" class="currency real">R$</label>
                    <money
                      :readonly="bounty_severity.active_campaign == true"
                      @input.native="mathAbsMoney('bounty_low')"
                      class="form-control mask-real"
                      v-model="bounty_severity.bounty_low"
                      placeholder="R$ 0,00"
                      maxLength="13"
                    />
                  </div>
                </td>
                <td
                  v-if="this.bounty_severity.active_campaign && this.bounty_severity.offers_double_bounty"
                  class="w-100 pl-0 text-muted"
                >
                  <div class="col-lg-24 col-mb-12" style="position: relative">
                    <label v-show="isDollar" class="currency">US$</label>
                    <label v-show="!isDollar" class="currency real">R$</label>
                    <money
                      readonly
                      class="form-control mask-real"
                      :value="
                        bounty_severity.offers_double_bounty
                          ? doubleBountyLow
                          : bounty_severity.bounty_low
                      "
                      placeholder="R$ 0,00"
                      maxLength="13"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  :class="[
                    'row',
                    'd-flex',
                    'align-content-center',
                    {
                      'col-lg-8':
                        this.bounty_severity.offers_double_bounty == true &&
                        this.bounty_severity.active_campaign,
                      'col-12':
                        !this.bounty_severity.active_campaign ||
                        !this.bounty_severity.offers_double_bounty,
                    },
                  ]"
                >
                  <Impact impact="impact-medium" class="mt-1" />
                  <strong class="mx-2" v-text="$ml.get('medium')">Médio</strong>
                </td>
                <td
                  :class="[
                    'pl-0',
                    'text-muted',
                    {
                      'col-lg-8':
                        this.bounty_severity.offers_double_bounty == true &&
                        this.bounty_severity.active_campaign,
                      'col-12':
                        !this.bounty_severity.active_campaign ||
                        !this.bounty_severity.offers_double_bounty,
                    },
                  ]"
                >
                  <div class="col-lg-24 col-mb-12" style="position: relative">
                    <label v-show="isDollar" class="currency">US$</label>
                    <label v-show="!isDollar" class="currency real">R$</label>
                    <money
                      :readonly="bounty_severity.active_campaign == true"
                      @input.native="mathAbsMoney('bounty_medium')"
                      class="form-control mask-real"
                      v-model="bounty_severity.bounty_medium"
                      placeholder="R$ 0,00"
                      maxLength="13"
                    />
                  </div>
                </td>
                <td
                  v-if="this.bounty_severity.active_campaign && this.bounty_severity.offers_double_bounty"
                  class="col-lg-8 w-100 pl-0 text-muted"
                >
                  <div class="col-lg-24 col-mb-12" style="position: relative">
                    <label v-show="isDollar" class="currency">US$</label>
                    <label v-show="!isDollar" class="currency real">R$</label>
                    <money
                      @input.native="mathAbsMoney('bounty_medium')"
                      class="form-control mask-real"
                      readonly
                      :value="
                        bounty_severity.offers_double_bounty
                          ? doubleBountyMedium
                          : bounty_severity.bounty_medium
                      "
                      placeholder="R$ 0,00"
                      maxLength="13"
                    />
                  </div>
                </td>
              </tr>

              <tr>
                <td
                  :class="[
                    'row',
                    'd-flex',
                    'align-content-center',
                    {
                      'col-lg-8':
                        this.bounty_severity.offers_double_bounty == true &&
                        this.bounty_severity.active_campaign,
                      'col-12':
                        !this.bounty_severity.active_campaign ||
                        !this.bounty_severity.offers_double_bounty,
                    },
                  ]"
                >
                  <Impact impact="impact-high" class="mt-1" />
                  <strong class="mx-2" v-text="$ml.get('high')">Alto</strong>
                </td>
                <td
                  :class="[
                    'pl-0',
                    'text-muted',
                    {
                      'col-lg-8':
                        this.bounty_severity.offers_double_bounty == true &&
                        this.bounty_severity.active_campaign,
                      'col-12':
                        !this.bounty_severity.active_campaign ||
                        !this.bounty_severity.offers_double_bounty,
                    },
                  ]"
                >
                  <div class="col-lg-24 col-mb-12" style="position: relative">
                    <label v-show="isDollar" class="currency">US$</label>
                    <label v-show="!isDollar" class="currency real">R$</label>
                    <money
                      :readonly="bounty_severity.active_campaign == true"
                      @input.native="mathAbsMoney('bounty_high')"
                      class="form-control mask-real"
                      v-model="bounty_severity.bounty_high"
                      placeholder="R$ 0,00"
                      maxLength="13"
                    />
                  </div>
                </td>
                <td
                  v-if="this.bounty_severity.active_campaign && this.bounty_severity.offers_double_bounty"
                  class="col-lg-8 w-100 pl-0 text-muted"
                >
                  <div class="col-lg-24 col-mb-12" style="position: relative">
                    <label v-if="isDollar" class="currency">US$</label>
                    <label v-else class="currency real">R$</label>
                    <money
                      @input.native="mathAbsMoney('bounty_high')"
                      class="form-control mask-real"
                      readonly
                      :value="
                        bounty_severity.offers_double_bounty
                          ? doubleBountyHigh
                          : bounty_severity.bounty_high
                      "
                      placeholder="R$ 0,00"
                      maxLength="13"
                    />
                  </div>
                </td>
              </tr>

              <tr>
                <td
                  :class="[
                    'row',
                    'd-flex',
                    'align-content-center',
                    {
                      'col-lg-8':
                        this.bounty_severity.offers_double_bounty == true &&
                        this.bounty_severity.active_campaign,
                      'col-12':
                        !this.bounty_severity.active_campaign ||
                        !this.bounty_severity.offers_double_bounty,
                    },
                  ]"
                >
                  <Impact impact="impact-critical" class="mt-1" />
                  <strong class="mx-2" v-text="$ml.get('critical')"
                    >Crítico</strong
                  >
                </td>
                <td
                  :class="[
                    'pl-0',
                    'text-muted',
                    {
                      'col-lg-8':
                        this.bounty_severity.offers_double_bounty == true &&
                        this.bounty_severity.active_campaign,
                      'col-12':
                        !this.bounty_severity.active_campaign ||
                        !this.bounty_severity.offers_double_bounty,
                    },
                  ]"
                >
                  <div class="col-lg-24 col-mb-12" style="position: relative">
                    <label v-show="isDollar" class="currency">US$</label>
                    <label v-show="!isDollar" class="currency real">R$</label>
                    <money
                      :readonly="bounty_severity.active_campaign == true"
                      @input.native="mathAbsMoney('bounty_critical')"
                      class="form-control mask-real"
                      v-model="bounty_severity.bounty_critical"
                      placeholder="R$ 0,00"
                      maxLength="13"
                    />
                  </div>
                </td>
                <td
                  v-if="this.bounty_severity.active_campaign && this.bounty_severity.offers_double_bounty"
                  class="col-lg-8 w-100 pl-0 text-muted"
                >
                  <div class="col-lg-24 col-mb-12" style="position: relative">
                    <label v-if="isDollar" class="currency">US$</label>
                    <label v-else class="currency real">R$</label>
                    <money
                      @input.native="mathAbsMoney('bounty_critical')"
                      class="form-control mask-real"
                      readonly
                      :value="
                        bounty_severity.offers_double_bounty
                          ? doubleBountyCritical
                          : bounty_severity.bounty_critical
                      "
                      placeholder="R$ 0,00"
                      maxLength="13"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100 mr-3">
        <div class="pl-3 mb-3 d-flex justify-content-between">
          <span
            ><strong class="mr-1" v-text="$ml.get('otherTypes')"
              >Outros tipos</strong
            >
            <span v-text="$ml.get('ofReward')">de recompensa</span></span
          >
        </div>

        <div class="d-flex pl-3 d-flex w-100 mb-3">
          <div class="row w-100 d-flex">
            <div class="col-22 col-md-17 col-lg-9 pr-3 mb-1">
              <multiselect
                v-model="selectedOthersRewards"
                :options="selectRewardOrType"
                :custom-label="nameLang"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="$ml.get('award')"
                :allow-empty="false"
                :preselect-first="true"
              >
              </multiselect>
            </div>
            <div
              v-show="selectedOthersRewards == 'others'"
              class="col-22 col-md-14 pr-3"
            >
              <input
                maxlength="100"
                type="text"
                v-model="txtOtherRewards"
                class="form-control"
                :placeholder="$ml.get('rewardDetails')"
              />
            </div>

            <div class="col d-flex mr-2 pointer">
              <a @click="addOtherRewards()" class="align-self-center">
                <img
                  src="../../../../src/assets/icons/plus-circle.png"
                  class="pointer d-flex mb-2 ico-16"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="card card-body ml-3 p-0 d-flex w-100">
          <div
            v-if="!optional_rewards.length"
            class="d-flex justify-content-center"
          >
            <h6 class="size-1_4 p-4" v-text="$ml.get('addOtherRewardsHere')">
              Adicione outras recompensas aqui!
            </h6>
          </div>
          <table v-else class="mb-2">
            <thead>
              <tr>
                <th class="col-16" v-text="$ml.get('reward')">Recompensa</th>
                <th class="col-6 pl-0"></th>
                <th class="col-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in optional_rewards" :key="index">
                <td class="col-22" v-text="item"></td>
                <td class="col-2 pl-0 d-flex justify-content-end">
                  <a class="pointer" @click="removeOtherRewards(index)">
                    <svg width="16" height="16">
                      <image
                        xlink:href="../../../../src/assets/icons/trash-alt.svg"
                        width="16"
                        height="16"
                      />
                    </svg>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-5"></span>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  name: "Rewards",
  props: {
    number: {
      type: String,
      required: true,
    },
    bounty_severity: {
      type: Array,
      required: false,
      default: Array,
    },
    optional_rewards: {
      type: Array,
      required: false,
      default: Array,
    },
    getCurrency: {
      type: Function,
      required: false,
      default: Function,
    },
    currency: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      validateError: false,
      txtOtherRewards: "",
      selectRewardOrType: ["weSendAToast", "thankByEmail", "others"],
      selectedOthersRewards: null,
      double_reward: 2,

      isDollar: null,
      optionSelected: {
        name: "BRL",
        value: "BRL",
      },
      listOptions: [
        {
          name: "BRL",
          value: "BRL",
        },
        {
          name: "USDT",
          value: "USDT",
        },
      ],
    };
  },
  watch: {
    optionSelected() {
      this.isDollar = this.optionSelected.value === "USDT" ? true : false;
      this.getCurrency(this.optionSelected.value);
    },
    currency() {
      if (this.currency === "USDT") {
        this.isDollar = true;
      }
    },
  },
  mounted() {
    this.getCurrency(this.optionSelected.value);
  },
  methods: {
    nameLang(name) {
      if (["weSendAToast", "thankByEmail", "others"].includes(name))
        return this.$ml.get(name);
      else return name;
    },
    langCurrency({ name }) {
      return `${this.$ml.get(name)}`;
    },

    mathAbsMoney(bounty) {
      this.bounty_severity[`${bounty}`] = Math.abs(
        this.bounty_severity[`${bounty}`]
      );
    },

    addOtherRewards() {
      var self = this;

      let newItem =
        this.selectedOthersRewards != "others"
          ? this.selectedOthersRewards
          : this.txtOtherRewards;
      let diference = false;

      if (newItem.trim() === "") {
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("enterYourRewardDetails"),
        });
        diference = true;
        return;
      }
      this.optional_rewards.forEach((element) => {
        if (element === this.nameLang(newItem)) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("itIsNotPossibleToEnterEqualRewards"),
          });
          diference = true;
          return;
        }
      });

      if (!diference) {
        this.optional_rewards.push(this.nameLang(newItem));
        this.txtOtherRewards = "";
      }
    },

    removeOtherRewards(item) {
      this.optional_rewards.splice(item, 1);
    },
  },

  computed: {
    doubleBountyLow() {
      return this.bounty_severity.bounty_low * this.double_reward;
    },
    doubleBountyMedium() {
      return this.bounty_severity.bounty_medium * this.double_reward;
    },
    doubleBountyHigh() {
      return this.bounty_severity.bounty_high * this.double_reward;
    },
    doubleBountyCritical() {
      return this.bounty_severity.bounty_critical * this.double_reward;
    },
  },
};
</script>
<style scoped>
.currency {
  position: absolute;
  left: 0px;
  top: -2.1px;
  transform: translate(6px, 67.7%);
  font-weight: 400;
  color: #495057;
}
.real {
  transform: translate(15px, 67.7%);
}
</style>
